import makeActionCreator from 'src/lib/makeActionCreator';
import { State } from 'src/redux/reducers/RootReducer';
import Debug from 'src/lib/Debug';
import {
  getFundraisingTransactionData,
  putFundraisingTransactionData,
} from 'src/apis/FundraisingTransactionAPI';
import { setAlert } from 'src/redux/actions/alertActions';
import { setFormStatus } from 'src/redux/actions/formActions';
import { ALERT_TYPE } from 'src/constants/AlertType';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { FundraisingTransaction } from 'src/models/FundraisingModel';
import { toOrgTimezone } from 'src/lib/DateHelper';

export const ADD_FUNDRAISING_TX = 'ADD_FUNDRAISING_TX';
export const REMOVE_FUNDRAISING_TX = 'REMOVE_FUNDRAISING_TX';

export const addFundraisingTransaction = makeActionCreator(ADD_FUNDRAISING_TX);

const normalizeTransaction = (data: any, timezone: string) => {
  const transaction = { ...data } as FundraisingTransaction;
  transaction.pledge_date = toOrgTimezone(data.pledge_date, timezone);
  return transaction;
};

export const getFundraisingTransactionAction: (id: string) => ThunkedAction<State> =
  (id: string) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setFormStatus({ [FORM.fundraisingTransaction]: FORM_STATUS.loading }));
      const state = getState();
      const organisation = state.currentOrganisation.id;
      const timezone = state.data.timezones[state.organisation.timezoneId];
      const response = await getFundraisingTransactionData(organisation, id);
      if (response.success) {
        dispatch(addFundraisingTransaction({
          id,
          transaction: normalizeTransaction(response.data, timezone),
        }));
        dispatch(setFormStatus({ [FORM.fundraisingTransaction]: FORM_STATUS.success }));
      } else {
        dispatch(setFormStatus({ [FORM.fundraisingTransaction]: FORM_STATUS.error }));
      }
    } catch (e) {
      Debug.errorLog(e);
      dispatch(setFormStatus({ [FORM.fundraisingTransaction]: FORM_STATUS.error }));
    }
  };

export const putFundraisingTransactionAction:
(fundraisingTransaction: FundraisingTransaction) => ThunkedAction<State> =
  (fundraisingTransaction: FundraisingTransaction) => async (dispatch: any, getState: any) => {
    const { id } = fundraisingTransaction;
    try {
      const state = getState();
      const organisation = state.currentOrganisation.id;
      const timezone = state.data.timezones[state.organisation.timezoneId];
      const response = await putFundraisingTransactionData(organisation, fundraisingTransaction);
      if (response.success) {
        dispatch(addFundraisingTransaction({
          id,
          transaction: normalizeTransaction(response.data, timezone),
        }));
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          message: 'Transaction successfully deleted',
        }));
        return;
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error deleting transaction',
      }));
    } catch (e) {
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error deleting transaction',
      }));
      Debug.errorLog(e);
    }
  };
